import { render, staticRenderFns } from "./BareLayout.vue?vue&type=template&id=461424ad&scoped=true&"
import script from "./BareLayout.vue?vue&type=script&lang=js&"
export * from "./BareLayout.vue?vue&type=script&lang=js&"
import style0 from "./BareLayout.vue?vue&type=style&index=0&id=461424ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461424ad",
  null
  
)

export default component.exports